import { omitBy, isNil } from 'lodash';

function cleanObjectParams(params) {
  return omitBy(params, isNil);
}

export default {
  cleanObjectParams,
};
